//客户个性化部署域名时使用的配置
//枣阳桃溯源
import zytsy from './zytsy';
export default () => {
  const configList = [zytsy()];
  return configList.find(item => !!item);
}
